import cn from 'classnames';
import PropTypes from 'prop-types';

import { CHECKOUT_STEP_MAP, REVIEW_STEP } from 'constants/checkoutFlow';

import BackButton from 'components/checkout/caap/BackButton';
import ListItem from 'components/checkout/caap/ListItem';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import { SmallLoader } from 'components/Loader';
import { toUSD } from 'helpers/NumberFormats';
import {
  first as styleFirst,
  item as styleItem,
  itemBox as styleItemBox,
  itemContainer as styleItemContainer,
  last as styleLast
} from 'styles/components/checkout/caap/contentBox.scss';
import styles from 'styles/components/checkout/caap/shipoption/shippingOptionsModal.scss';

const ShippingOptionsModal = ({ sectionKey, hideContinueButton = false, isFetchingCheckoutData, shipOptions, onShipOptionSelected, selectedShipOptionId, shipPromise, onUseShipOptionClick }, { testId }) => {
  if (!shipOptions.length) {
    return <SmallLoader />;
  }

  return (
    <div>
      <BackButton href={CHECKOUT_STEP_MAP[REVIEW_STEP]} />

      <div className={styles.primaryHeading}>
        <h2>Choose your shipping options</h2>
      </div>

      <legend className={styles.legend}>Choose a shipping speed</legend>

      <div>

        {shipOptions.map((type, index) => {
          const {
            id,
            promise,
            price
          } = type;

          const itemBoxClasses = cn(
            styleItemBox,
            {
              [styleFirst]: index === 0,
              [styleLast]: index === shipOptions.length - 1
            }
          );

          return (
            <div className={styleItemContainer} key={`address-list-${index}`} data-test-id={testId('shipOptionBlock')}>
              <div className={itemBoxClasses}>
                <div className={styleItem}>
                  <div className={styles.shipOptionItem}>
                    <ListItem
                      itemKey={id}
                      index={`shipOptions-${sectionKey}-${index}`}
                      key={`shipOptions-${sectionKey}-${id}`}
                      onChange={onShipOptionSelected}
                      isChecked={selectedShipOptionId === id}
                      isDisabled={isFetchingCheckoutData}
                    >
                      <Row>
                        <RowSpan span="12">
                          <span data-test-id={testId('shippingOptionDetails')}>{`${promise} ${formatPrice(price)}`}</span>
                        </RowSpan>
                      </Row>
                    </ListItem>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {
        hideContinueButton
          ? null
          : <div>
            <button
              type="button"
              className={styles.checkoutPrimaryButton}
              disabled={isFetchingCheckoutData || !selectedShipOptionId && !shipPromiseIsValid(shipPromise, shipOptions)}
              onClick={onUseShipOptionClick}
              data-test-id={testId('shippingOptionsContinueButton')}>
            Continue
            </button>
          </div>
      }

    </div>
  );
};

ShippingOptionsModal.contextTypes = {
  testId: PropTypes.func
};

const formatPrice = price => {
  if (typeof price === 'undefined') {
    return '';
  }
  return price === 0 ? '- FREE' : `- ${toUSD(price)}`;
};

const shipPromiseIsValid = (shipPromise, options) => {
  const valid = (options || []).find(item => item.promise === shipPromise);
  return !!valid;
};

export default ShippingOptionsModal;
